import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css';
import { Link, Typography,Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux/es/exports";
import Avatar from '@mui/material/Avatar';
function DashboardNavbar(){

  const navigate  = useNavigate();
  const userFromRedux = useSelector((a)=>a.user)
  let login=()=>{
    navigate("/login")
  }

 let bookingRecord=()=>{
    navigate("/bookingRecord")
 }
 
 let home = ()=>{
    navigate("/userScreen")
 }



    return (
        <>
        <nav class="navbar shadow navbar-expand-lg navbar-light bg-light position-sticky">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Hotel Management App</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a onClick={home} class="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" onClick={bookingRecord}>Booking Detail</a>
        </li>
       
        <li class="nav-item">
          <a class="nav-link" href="#">Contact Us</a>
        </li>
       
        {/* <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li> */}
      </ul>
      <Box>
      <Avatar alt="Remy Sharp" src="https://thumbs.dreamstime.com/b/businessman-faceless-profile-avatar-isolated-vector-illustration-graphic-design-143627091.jpg" />
      </Box>
      <form class="d-flex" >
        <Typography sx={{color:"black",padding:"20px"}} variant="h5">Username:   {userFromRedux.userName}</Typography>
      </form>

      <form class="d-flex">
        <Link to="/login">

        <button onClick={login} class="btn btn-primary m-2" type="submit">Logout</button>
        </Link>
      </form>
    </div>
  </div>

  
</nav>
   <div>
    
    </div>     
        
        </>
    )
}

export default DashboardNavbar;